import { dynamicApiSlice } from "./dynamicApi";

export interface FeatureFlags {
  ManageAccess: boolean;
  Rename: boolean;
  Archive: boolean;
  Edit: boolean;
}

export const featureFlagsApi = dynamicApiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getFeatureFlags: builder.query<FeatureFlags, void>({
      query: () => "FeatureFlags",
      keepUnusedDataFor: Infinity,
    }),
  }),
  overrideExisting: false,
});

export const { useGetFeatureFlagsQuery } = featureFlagsApi;